// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"98a1cbce","310":"45b62ae1","364":"c17607aa","378":"59fc2973","483":"a4bba779","607":"430a6eab"}[chunkId] + ".chunk.js";
};